import React from "react";
import styles from "./styles/DashboardCard.module.scss";
import CountUp from "react-countup";

interface DashboardCardProps {
  icon: React.ReactNode;
  number: number;
  text: string;
  cardBg: string;
}

const DashboardCard: React.FC<DashboardCardProps> = ({
  icon,
  number,
  text,
  cardBg,
}) => {
  return (
    <div className={`${styles.Card}`}>
      <div className={styles.info}>
        <p className={`${styles.title} fs-6 m-0`}>{text}</p>
        <p className={`${styles.count} fs-2 fw-bold m-0`}>
          <CountUp end={number} />
        </p>
      </div>
      <div className={`${styles.iconCard}`} style={{ backgroundColor: cardBg }}>
        {icon}
      </div>
    </div>
  );
};

export default DashboardCard;
